import { render, staticRenderFns } from "./_side-bar.vue?vue&type=template&id=4e037156&scoped=true&"
import script from "./_side-bar.vue?vue&type=script&lang=js&"
export * from "./_side-bar.vue?vue&type=script&lang=js&"
import style0 from "./_side-bar.vue?vue&type=style&index=0&id=4e037156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e037156",
  null
  
)

export default component.exports